import { Meta } from '@storybook/addon-docs';
import { TokensGrid } from '../../components/TokensGrid';
import { fontWeights } from '@rocketseat-ignite-ui/tokens';

<Meta title='Tokens/Font Weights' />

# Font Weights

<TokensGrid tokens={fontWeights} />
